import React from 'react';

import { Tooltip, TooltipPosition, TooltipProps } from '@tableau/widgets';
import { FavoriteToggle } from './FavoriteToggle';
import { FavoriteToggleTooltipContent } from './FavoriteToggleTooltipContent';

export class FavoriteToggleWithCounts extends React.PureComponent<FavoriteToggleWithCounts.Props, FavoriteToggleWithCounts.State> {

  constructor(props: FavoriteToggleWithCounts.Props, state: FavoriteToggleWithCounts.State) {
    super(props, state);
    this.state = { favoritesCount: props.favoritesCount, isFavorite: props.isFavorite };
  }

  private getTooltipContent = () => {
    return <FavoriteToggleTooltipContent isFavorite={this.state.isFavorite} favoritesCount={this.state.favoritesCount} />;
  }

  public render() {
    const tooltipProps: TooltipProps = {
      followCursor: false,
      position: TooltipPosition.Top,
      testId: 'favorites-count',
      getContent: this.getTooltipContent,
      maxWidth: 160
    };

    return (
      <Tooltip {...tooltipProps} >
        <FavoriteToggle
          isFavorite={this.state.isFavorite}
          onAddFavorite={this.onAddFavoriteAndUpdateCount}
          onRemoveFavorite={this.onRemoveFavoriteAndUpdateCount}
          isTabbable={this.props.canHaveKeyboardFocus}
          hideHelpTooltip={true} />
      </Tooltip>
    );
  }

  private onAddFavoriteAndUpdateCount = () => {
    this.props.onAddFavorite();
    this.setState({ favoritesCount: this.state.favoritesCount + 1, isFavorite: true });
  }

  private onRemoveFavoriteAndUpdateCount = () => {
    this.props.onRemoveFavorite();
    this.setState({ favoritesCount: this.state.favoritesCount - 1, isFavorite: false });
  }
}

export namespace FavoriteToggleWithCounts {
  export interface Props {
    isFavorite: boolean;
    onAddFavorite: () => void;
    onRemoveFavorite: () => void;
    canHaveKeyboardFocus: boolean;
    favoritesCount: number;
  }

  export interface State {
    favoritesCount: number;
    isFavorite: boolean;
  }
}
